const init = () => {
    const $component = $('.c-book-block-hero');
    if (!$component.length) return;

    // Handle image loading with CLS prevention
    initImageLoading();

    function initImageLoading() {
        // Handle image loading with CLS prevention
        const images = $component.find('img');
        images.each(function() {
            const $img = $(this);
            const $container = $img.closest('.c-book-block-hero__thumb');
            
            if ($img[0].complete) {
                $img.addClass('loaded');
                $container.addClass('image-loaded');
            } else {
                $img.on('load', function() {
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
                $img.on('error', function() {
                    // Still fade in on error to prevent infinite loading state
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
            }
        });
    }
};

export default init;
